:host {
  /**
   * @prop --max-width: The maximum width of the module.
  */
  display: block;
  .overlay{
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    z-index: 1002; // DNN default theme has menus on z-index 1001
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(2px);
    transition: all 300ms ease-in-out;
    visibility: hidden;
    opacity: 0;
    .modal{
      max-width: var(--max-width, 1200px);
      background-color: white;
      padding: 30px;
      transform: scale(2);
      transition: transform 300ms ease-in-out;
      z-index: 2;
      position: relative;
      max-height: 80%;
      border-radius: var(--dnn-controls-radius, 5px);
      box-shadow: 10px 10px 20px 0 rgba(0,0,0,0.5);
      display: block;
      .content{
        max-width: 80vw;
        max-height: 80vh;
        overflow: auto;
      }
      .se {
        position: absolute;
        height: 10px;
        width: 10px;
        bottom: -5px;
        right: -5px;
        cursor: se-resize;
      }
      .close{
        position: absolute;
        background-color:white;
        border: 2px solid white;
        border-radius: 50%;
        padding: 0;
        margin: 0;
        top: -12px;
        right: -12px;
        outline: none;
        display: flex;
        justify-content: center;
        align-items: center;
        &:focus-visible, &:hover{
          box-shadow: 0 0 2px 2px var(--dnn-color-primary, blue);
        }
        svg{
          width: 24px;
          height: 24px;
          color: grey;
        }
      }
    }
    &.visible{
      visibility: visible;
      opacity: 1;
      .modal{
        transform: scale(1);
        box-shadow: 4px 4px 10px 0px rgba(0,0,0,0.5);
        display: block;
      }
    }
  }
}